import UntypedCheckbox from '@/components/FormElements/Checkbox';
import type { ComponentType } from 'react';

// Checkbox is an untyped .jsx component; type the props Table actually uses.
export interface TableCheckboxProps {
  id?: string;
  checked?: boolean;
  indeterminate?: boolean;
  onChange?: () => void;
  invertedColor?: boolean;
  ariaLabel?: string;
}

export const TypedCheckbox =
  UntypedCheckbox as unknown as ComponentType<TableCheckboxProps>;
